import { IAdapterData } from '../../types';
import { IAlacarte, IModule, IPriceSummary } from '../PolicyListSlice/types';

export interface IModularEnrolmentSlice {
    policyId: string;
    currentStep: ModularEnrolmentSteps; // to track user state i.e page number
    selectedBasePlan: string;
    selectedAlaCarte: string[];
    selectedAddOns?: string[]; // for add-on benefits
    family: IAdapterData<IModularFamily[]>;
    basePlans: IAdapterData<IModule[]>; // from api
    alaCarteBenefits: IAdapterData<IAlacarte[]>;
    addOnBenefits: IAdapterData<IAlacarte[]>;
    balance?: number; // for wallet
    personalEmail?: string;
    upgradedFamilyStructure?: string;
    crudFamily: IAdapterData<ICRUDResponse>;
    summary: IAdapterData<IModularEnrolmentSummary>;
    userBenefits?: IUserBenefits; // benefitId --> userIds
    purchaseAttributes?: ISelectedAttributes;
}

// benefitId --> extended family (outside base plan)
export interface ISelectedAlaCarteBenefit {
    cost: number;
    extraDependants: IModularFamily[];
}

export type IUserBenefits = Record<string, string[]>; // benefitId --> userIds
export type IPurchaseAttributes = Record<
    string,
    {
        type: 'text' | 'single-select';
        label: string;
        required: boolean;
        suffix?: string;
        prefix?: string;
        category?: string;
        options?: string[];
    } | null
>;

export type IPurchaseAttributePayload = Record<
    string, // benefitId (e.g., "BEN-741212")
    {
        userSelection: {
            [userId: string]: Record<string, string>; // userId -> attribute fields
        };
    }
>;

export type ISelectedAttributes = Record<
    string, // benefitId key
    {
        [userId: string]: Record<string, string>; // userId -> attribute fields
    } | null
>;
export interface ISelectedPurchaseAttributes {
    userSelection: {
        [userId: string]: {
            [attributeKey: string]: string;
        };
    };
}

export interface IModularEnrolmentSummary {
    modular: IModule;
    alacarte: IAlacarte[];
    priceSummary: IPriceSummary;
}

export enum ModularEnrolmentSteps {
    BASE_PLAN = 0,
    DEPENDENTS = 1,
    HEALTHCARE_BENEFITS = 2,
    SUMMARY = 3
}

export interface IFetchModularPlansPayload {
    selectedPlanId?: string;
    plans: IModule[];
}

export interface IFetchBenefitsByTypeResponse {
    benefits: {
        modular: IModule[];
        alacarte: IAlacarte[];
        addOn?: IAlacarte[];
    };
    email: string;
}

export interface IFetchModularSummaryResponse {
    modular: IModule[];
    alacarte: IAlacarte[];
    addOn: IAlacarte[];
    priceSummary: IPriceSummary;
}

export interface IModularFamily {
    id: string;
    firstName: string;
    lastName: string;
    dob: string;
    relationship: string;
    email: string;
    mobile: string;
    employer: string;
    employeeId: string;
    gender: IGender;
}

export interface IFetchModularFamilyResponse {
    family: IModularFamily[];
}
export interface IFetchModularAlaCartePayload {
    benefits: IAlacarte[];
    selectedBenefits: string[];
    personalEmail: string;
    userBenefits: Record<string, string[]>;
    purchaseAttributes?: ISelectedAttributes;
}

export interface IFetchModularAddOnPayload {
    addOns: IAlacarte[];
    selectedAddOns: string[];
    upgradedFamilyStructure: string;
}

export type IGender = 'male' | 'female';

export interface ISaveMemberPayload {
    firstName: string;
    lastName: string;
    dob: string;
    relationship: string;
    mobile?: string;
    employer: string;
    employeeId: string;
    gender: IGender;
}

export interface ICRUDResponse {
    message?: string;
    userId?: string;
}

export interface IAlaCarteDB {
    id: string;
    name: string;
    tierId?: string;
    metadata: {
        logo: string;
    };
}
